import { getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function GetTeam(teamId) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/admin/teams/' + teamId, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch teams.' },
      { status: 500 }
    ));
  }

  const resData = await response.json();
  return resData.data;
}

export async function ListTeams(page, options = {}) {
  const token = getAuthToken()

  if (token === null) {
    return { data: [], pagination: {} }
  }

  let queryParams = []
  if (page) {
    queryParams.push("page=" + page)
  }
  if (options.skip_pagination) {
    queryParams.push("skip_pagination=1")
  }
  if (options.filters) {
    Object.keys(options.filters).forEach((key) => {
      const value = options.filters[key]
      if (value !== undefined && value !== null && value !== "") {
        queryParams.push(`filters[${key}]=` + encodeURIComponent(value))
      }
    })
  }

  const url = config.apiBaseUrl + `/rest/admin/teams` + (queryParams.length > 0 ? `?${queryParams.join("&")}` : '')
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch groups.' },
      {
        status: 500,
      }
    ));
  }

  return await response.json();
}

export async function AutoCompleteTeams(q) {
  const token = getAuthToken()

  if (token === null) {
    return []
  }

  const url = config.apiBaseUrl + `/rest/admin/teams/search?q=` + q
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch groups.' },
      {
        status: 500,
      }
    ));
  }

  return await response.json();
}

export async function TeamCreate(team) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/teams', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify(team)
  })

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  } else {
    const resData = await response.json();
    return { status: response.status, data: resData.data }
  }
}

export async function TeamUpdate(id, team) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/teams/' + id, {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify(team)
  })

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  } else {
    const resData = await response.json();
    return { status: response.status, data: resData.data }
  }
}

export async function DeleteTeam(teamId) {
  const response = await fetch(config.apiBaseUrl + `/rest/admin/teams/${teamId}`, {
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    }
  })

  if (!response.ok) {
    return false;
  } else {
    return true;
  }
}
